import {BaseFormModel} from './base-form-model';

export class Login extends BaseFormModel<Login> {
    email: string;
    password: string;
    changePassword: string;
    confirmedEmail: boolean;
}
